/* eslint-disable */ //todo: check but probably select will be moved to prime implementation
import {
  AfterContentChecked, ChangeDetectionStrategy, ChangeDetectorRef, Component,
  ContentChildren, DestroyRef, forwardRef, inject, Input, OnInit, QueryList, Renderer2,
  ViewChild
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CwSelectOptionComponent } from './select-option/select-option.component';
import { CwSelectedOption, CwSelectService } from './select.service';
import { CwInputComponent } from '../input/input.component';
import { CdkOverlayOrigin, ViewportRuler } from "@angular/cdk/overlay";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";

const CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CwSelectComponent),
    multi: true
};
const emptyFn = (_?: any) => {
};

@Component({
    selector: 'cw-select',
    styleUrls: [
        'select.component.scss'
    ],
    providers: [
        CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR,
        CwSelectService
    ],
    templateUrl: 'select.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class CwSelectComponent implements ControlValueAccessor, OnInit, AfterContentChecked {

    @Input()
    public label!: string;

    public inputValue: any;
    public overlayWidth: string | number;
    public onTouchedCallback: () => void = emptyFn;
    public onChangedCallback: (_: any) => void = emptyFn;

    protected _model: any;
    protected _isExpanded = false;

    @ContentChildren(CwSelectOptionComponent)
    protected options!: QueryList<CwSelectOptionComponent>;

    @ViewChild(CwInputComponent)
    protected input!: CwInputComponent;

    @ViewChild('trigger')
    protected trigger: CdkOverlayOrigin;

    protected onClickBodyUnbind!: () => void;

    private destroyRef = inject(DestroyRef);

    constructor(
        protected selectService: CwSelectService,
        protected renderer: Renderer2,
        protected cd: ChangeDetectorRef,
        private viewportRuler: ViewportRuler
    ) {
    }

    public ngOnInit(): void {
        this.selectService.selectOptionTopic$
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe((selectedOption: CwSelectedOption) => {
                this.model = selectedOption.value;
            });
        this.viewportRuler.change()
            .pipe(takeUntilDestroyed(this.destroyRef))
            .subscribe(() => {
                if (this.isExpanded) {
                    this.setOverlayWidth();
                }
            });
    }

    public ngAfterContentChecked(): void {
        this.onChangeModel();
    }

    public get isExpanded(): boolean {
        return this._isExpanded;
    }

    public set isExpanded(value: boolean) {
        this._isExpanded = value;
        this.cd.markForCheck();
    }

    public openList(): void {
        if (this.isExpanded) {
            return;
        }

        this.setOverlayWidth();
        this.isExpanded = true;
        this.input.focus();

        setTimeout(
            () => {
                this.onClickBodyUnbind = this.renderer.listen(
                    'body',
                    'click',
                    () => {
                        this.isExpanded = false;
                        this.input.focus();
                        this.onClickBodyUnbind();
                    }
                );
            },
            0
        );
    }

    public get model(): any {
        return this._model;
    }

    public set model(value: any) {
        if (value !== this._model) {
            this._model = value;
            this.onChangedCallback(value);
            this.onChangeModel();
        }
    }

    public writeValue(obj: any): void {
        this.model = obj;
    }

    public registerOnChange(fn: any): void {
        this.onChangedCallback = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouchedCallback = fn;
    }

    protected onChangeModel(): void {
        const selectedOption = this.options?.find((option: CwSelectOptionComponent) => {
            return option.value === this.model;
        });

        if (selectedOption) {
            this.inputValue = selectedOption.label;
            this.cd.markForCheck();
        }
    }

    private setOverlayWidth(): void {
        this.overlayWidth = this.trigger.elementRef.nativeElement.getBoundingClientRect().width;
        this.cd.detectChanges();
    }
}
